import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {RequestType} from '../../../core/shared/model/RequestType';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {RefreshDate} from '../../../core/shared/model/RefreshDate';
import {StatementsService} from '../statements.service';
import {UserService} from '../../../core/services/user.service';
import {FSInvoiceDialogService} from '../../../core/services/fsinvoice.dialog.service';
import * as moment from 'moment';
import {ExcelService} from "../../../core/services/excel.service";
import {LoggingService} from "mclane-apptemplate-lib";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';
@Component({
  selector: 'app-statements',
  templateUrl: './statements.component.html',
  styleUrls: ['./statements.component.scss'],
  providers: [ExcelService]
})

export class StatementsComponent implements OnInit {
  firstckboxchecked: boolean = true;
  selectedRequestType: string;
  dateRangeChk: boolean = false;
  selectedInvType: string;
  selectedStartDate: Date;
  startDate: Date;
  selectedEndDate: Date = moment().toDate();
  selectForm: FormGroup;
  currentDate: RefreshDate = new RefreshDate();
  monthEndDate: RefreshDate = new RefreshDate();
  historyDate: RefreshDate = new RefreshDate();
  nextDisabled: boolean = false;
  maxEndDate: Date = moment().toDate();
  minEndDate: Date = moment().subtract(18, 'months').toDate();
  historySelected: boolean = false;
  userToken: any;

  public requesttypes: RequestType[] = [
    {id: 'D', text: 'Current Open Items as of :', checked: true},
    {id: 'M', text: 'Month End Open Items as of :', checked: false},
    {id: 'H', text: 'Invoice History for Date Range specified below', checked: false},
  ];

  public daterequesttypes: RequestType[] = [
    {id: 'I', text: 'Invoice Date Range', checked: true},
    {id: 'N', text: 'Net Due Date Range', checked: false},
    {id: 'D', text: 'Discount Due Date Range', checked: false},
  ];

  constructor(public statementsService: StatementsService, public userService: UserService, private fsInvoiceDialog: FSInvoiceDialogService,
              private _route: ActivatedRoute, private _router: Router, public console: LoggingService, public loadingIndicator: LoadingIndicatorHelper) {
  }

  showOptions(event) {
    event.valueMerger();
  }

  async ngOnInit() {
    this.initForm();
    this.refreshForm();
    this.selectedInvType = 'I';
    await this.statementsService.getAsOfDate('D').subscribe(async retDate => {
        this.currentDate = Object.assign(new RefreshDate(), retDate);
        this.userService.setOriginalStartDate(this.currentDate);
        await this.statementsService.getAsOfDate('M').subscribe(async retDate => {
            this.monthEndDate = Object.assign(new RefreshDate(), retDate);
            await this.statementsService.getAsOfDate('H').subscribe(retDate => {
                this.historyDate = Object.assign(new RefreshDate(), retDate);
                this.loadingIndicator.hide();
              }
            );
          }
        );
      }
    );
  }

  initForm() {
     if (this.userService.getSelectedStartDate()) {
      this.selectedStartDate = moment(this.userService.getSelectedStartDate()).toDate();
      this.startDate = this.selectedStartDate;
       this.startDate = this.selectedStartDate;
       if (this.startDate.getFullYear() === 1900 && this.startDate.getMonth() === 1){
         this.startDate = null;
       }
    }

    this.selectedEndDate = moment(this.userService.getSelectedEndDate()).toDate();
    this.selectedInvType = this.userService.getSelectedInvType();
    this.selectedRequestType = this.userService.getSelectedRequestType();
    this.dateRangeChk = this.userService.getDateRangeChk();
    this.selectForm = new FormGroup({
      invoiceType: new FormControl(this.selectedInvType, [Validators.required]),
      requestType: new FormControl(this.selectedRequestType, Validators.required),
      selectedStartDate: new FormControl(this.maxEndDate, [Validators.required]),
      selectedEndDate: new FormControl(this.maxEndDate, [Validators.required]),
    });
  }

  selectedStartDateChange() {
    if (!(event instanceof KeyboardEvent)) {
    }
  }

  selectedEndDateChange() {
    if (!(event instanceof KeyboardEvent)) {
    }
  }

  nextClicked() {
    this.refreshForm();
    this.userService.setSelectedRequestType(this.selectedRequestType);
    this.userService.setSelectedStartDate(this.selectedStartDate);
    this.userService.setSelectedEndDate(this.selectedEndDate);
    this.userService.setSelectedInvType(this.selectedInvType);
    this.userService.setDateRangeChk(this.dateRangeChk);
    let navigationExtras: NavigationExtras = {
      queryParams: {}
    };
    if (this.dateRangeChk && this.selectForm.get('selectedStartDate').value == null) {

      this.fsInvoiceDialog.showMessageDialog('Start Date', 'You must enter a Start Date');
    } else {
      this._router.navigate(['/statementparents'], navigationExtras);
    }
  };

  private refreshForm() {
    this.selectForm.get('requestType').valueChanges
      .subscribe((value) => {
        if (value == null) {
          return;
        }
        if (value === 'H') {
          this.dateRangeChk = true;
          this.selectedStartDate = this.maxEndDate;
          this.selectedEndDate  = this.maxEndDate;
        } else if ( value === 'M') {
          this.dateRangeChk = false;
          this.selectedEndDate = this.currentDate.asOfDate;
          this.selectedStartDate = moment(new Date(1900,1,1)).toDate();
        } else {
          this.dateRangeChk = false;
          this.selectedEndDate = moment().toDate();
          this.selectedStartDate = moment(new Date(1900,1,1)).toDate();
        }
        this.selectedRequestType = value;
      });

    this.selectForm.get('invoiceType').valueChanges
      .subscribe((value) => {
        if (value == null) return;
        if (this.selectedRequestType !== 'H') {
          this.selectedInvType = 'I';
        } else {
          this.selectedInvType = value;
        }
      });

    this.selectForm.get('selectedStartDate').valueChanges
      .subscribe((value) => {
        if (value == null) return;
        this.selectedStartDate = value;
      });

    this.selectForm.get('selectedEndDate').valueChanges
      .subscribe((value) => {
        if (value == null) return;
        this.selectedEndDate = value;
      });
  }

  historySelect() {
    this.historySelected = true;
  }


}
